import { create } from 'zustand';
import { makeGet, makePatch, makePost } from '../../utils/call-api-endpoint';
import type { PaginatedList } from '../common/padinated-list';
import {
  toQueryString,
  type PaginationQueryParamsWithStatus
} from '../common/pagination-query-params';
import { useUIStore } from '../ui/ui.store';
import type { AgrupacionArticulos } from './agrupacion-articulos';

export interface AgrupacionesArticulosState {
  list: PaginatedList<AgrupacionArticulos>;
  current: AgrupacionArticulos;
  actives: AgrupacionArticulos[];

  nuevo: () => void;
  cargarPaginadas: (params: PaginationQueryParamsWithStatus) => Promise<void>;
  cargarPorIdGrupo: (idGrupo: number) => Promise<void>;
  cargarPorId: (id: number) => Promise<void>;
  registrar: (request: RegistrarAgrupacionArticulos) => Promise<boolean>;
  actualizar: (id: number, request: ActualizarAgrupacionArticulos) => Promise<boolean>;
  eliminar: (id: number) => Promise<boolean>;
}

export interface RegistrarAgrupacionArticulos {
  nombre: string;
  idGrupo: number;
}

export interface ActualizarAgrupacionArticulos {
  nombre: string;
  idGrupo: number;
}

const { showSuccessToast } = useUIStore.getState();

export const useAgrupacionArticulosStore = create<AgrupacionesArticulosState>()((set, get) => ({
  list: {
    items: [],
    pageIndex: 0,
    pageSize: 10,
    totalRows: 0
  },
  current: {} as AgrupacionArticulos,
  actives: [],

  nuevo: () =>
    set({
      current: {} as AgrupacionArticulos
    }),
  cargarPaginadas: async (params: PaginationQueryParamsWithStatus) => {
    const data = await makeGet<PaginatedList<AgrupacionArticulos>>(
      `/agrupaciones-articulos/paginadas?${toQueryString(params)}`
    );

    if (data.isFailure) return;

    set({
      list: data.result
    });
  },
  cargarPorIdGrupo: async (idGrupo: number) => {
    const data = await makeGet<Array<AgrupacionArticulos>>(`/agrupaciones-articulos/grupo/${idGrupo}`);

    if (data.isFailure) return;

    set({
      actives: data.result
    });
  },
  cargarPorId: async (id: number) => {
    const data = await makeGet<AgrupacionArticulos>(`/agrupaciones-articulos/${id}`);

    if (data.isFailure) return;

    set({
      current: data.result
    });
  },
  registrar: async (request: RegistrarAgrupacionArticulos) => {
    const data = await makePost<RegistrarAgrupacionArticulos, AgrupacionArticulos>(
      '/agrupaciones-articulos/',
      request
    );

    if (data.isFailure) return false;

    showSuccessToast('Registro agregado');

    set({
      current: {} as AgrupacionArticulos
    });

    return true;
  },
  actualizar: async (id: number, request: ActualizarAgrupacionArticulos) => {
    const data = await makePatch<ActualizarAgrupacionArticulos, AgrupacionArticulos>(
      `/agrupaciones-articulos/${id}`,
      request
    );

    if (data.isFailure) return false;

    showSuccessToast('Registro actualizado');

    set({
      current: {
        ...get().current,
        ...request
      }
    });

    return true;
  },
  eliminar: async (id: number) => {
    const data = await makePatch(`/agrupaciones-articulos/${id}/eliminar`);

    if (data.isFailure) return false;

    showSuccessToast('Registro eliminado');

    set({
      current: {} as AgrupacionArticulos
    });

    return true;
  }
}));
